export default "__VITE_ASSET__CHoM5kWR__"